import React, { useEffect, useState } from "react";
import AppNav from "@/components/site/AppNav";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function History() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    api.get("/studio/history?limit=100").then((r) => setItems(r.data.items)).finally(() => setLoading(false));
  }, []);

  const filtered = filter === "all" ? items : items.filter((i) => i.kind === filter);

  return (
    <div className="min-h-screen bg-background" data-testid="history-page">
      <AppNav />
      <main className="max-w-[1400px] mx-auto">
        <section className="p-8 md:p-12 border-b border-border">
          <div className="overline text-muted-foreground">Library</div>
          <h1 className="font-serif-display text-4xl md:text-6xl leading-none tracking-tight mt-4">
            Every draft, forever.
          </h1>
          <div className="mt-6 flex gap-0">
            {["all", "text", "image"].map((f, i) => (
              <button
                key={f}
                onClick={() => setFilter(f)}
                className={`px-5 py-2 border border-border overline uppercase ${filter === f ? "bg-foreground text-background" : "hover:bg-muted"} ${i > 0 ? "border-l-0" : ""}`}
                data-testid={`filter-${f}`}
              >
                {f}
              </button>
            ))}
          </div>
        </section>
        <section className="p-6 md:p-8">
          {loading ? (
            <div className="text-muted-foreground overline">Loading…</div>
          ) : filtered.length === 0 ? (
            <div className="border border-dashed border-border p-16 text-center">
              <div className="font-serif-display text-2xl">No drafts yet</div>
              <Link to="/studio" className="inline-block mt-6">
                <Button className="rounded-none h-11 px-6 font-mono uppercase tracking-widest text-xs">Start writing</Button>
              </Link>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-0 border-l border-t border-border">
              {filtered.map((h) => (
                <article key={h.id} className="p-6 border-r border-b border-border" data-testid={`draft-${h.id}`}>
                  <div className="flex items-center justify-between overline">
                    <span className="text-primary uppercase">{h.tool}</span>
                    <span className="text-muted-foreground">
                      {new Date(h.created_at).toLocaleDateString()}
                    </span>
                  </div>
                  <h3 className="mt-3 font-medium line-clamp-2">{h.prompt}</h3>
                  {h.kind === "image" ? (
                    <img src={h.output} alt={h.prompt} className="mt-4 w-full aspect-square object-cover border border-border" />
                  ) : (
                    <pre className="mt-3 whitespace-pre-wrap text-xs font-mono text-muted-foreground max-h-40 overflow-hidden line-clamp-6">
                      {h.output}
                    </pre>
                  )}
                </article>
              ))}
            </div>
          )}
        </section>
      </main>
    </div>
  );
}
